import apiClient from "../api/apiClient";
import ENDPOINTS from "../api/endPoint";

export const getCreditLines = (userId) => {
  return apiClient(ENDPOINTS.CREDITLINE.GET_BY_CUSTOMER(userId), {
    method: "GET",
  });
};

export const getCreditLineById = (creditLineId) => {
  return apiClient(ENDPOINTS.CREDITLINE.GET_BY_ID(creditLineId), {
    method: "GET",
  });
};

export const createCreditLine = (payload) => {
  return apiClient(ENDPOINTS.CREDITLINE.CREATE, {
    method: "POST",
    body: payload,
  });
};

export const updateCreditLine = (id, payload) => {
  return apiClient(ENDPOINTS.CREDITLINE.UPDATE(id), {
    method: "PUT",
    body: payload,
  });
};

export const deleteCreditLine = (creditLineId) => {
  return apiClient(ENDPOINTS.CREDITLINE.DELETE(creditLineId), {
    method: "DELETE",
  });
};


// Creditline Heirarchy  Validation api
export const validateCreditLineHierarchy = (cid) => {
  return apiClient(ENDPOINTS.CREDITLINE.VALIDATE_HIERARCHY(cid), {
    method: "GET",
  });
};

